import React from 'react';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { GridCentralPanelProps } from '../grid-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    transitionButton: {
      margin: theme.spacing(),
      alignSelf: 'baseline',
    },
  })
);

export function GridTransitionButtons(props: GridCentralPanelProps) {
  const classes = useStyles();
  const { handleNext, handlePrevious } = props;

  return (
    <div>
      <Button
        component="span"
        variant="text"
        className={classes.transitionButton}
        disabled={!handlePrevious}
        onClick={handlePrevious}
      >
        Předchozí
      </Button>
      <Button
        component="span"
        variant="text"
        className={classes.transitionButton}
        disabled={!handleNext}
        onClick={handleNext}
      >
        Další
      </Button>
    </div>
  );
}
